import * as React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { SHARE_CONSTANTS } from 'client/constants';
import { share } from 'common/utils';
import { dataLayerEvents } from 'common/utils/analytics';

import whatsAppIcon from 'assets/client/imgs/social/watsapp-icon.png';
import fbIcon from 'assets/client/imgs/social/fb-icon.png';
import AccessibilityIcon from '../AccessibilityIcon';

import * as css from './Socials.scss';

export default class Socials extends React.Component {
	static propTypes = {
		className: PropTypes.string,
	};

	static defaultProps = {
		className: '',
	};

	onShare = e => {
		const type = e.currentTarget.id;
		const options = { type };

		share(options, () => dataLayerEvents.onShareClick(type));
	};

	render() {
		const { className } = this.props;

		return (
			<div className={classNames(css.socials, className)}>
				<div className={css.overflowWrap}>
					<div className={css.btnsWrap}>
						<button
							type="button"
							className={css.whatsAppBtn}
							id={SHARE_CONSTANTS.WHATSAPP}
							onClick={this.onShare}
						>
							<img src={whatsAppIcon} alt="wt-icon" />
						</button>
						<button
							type="button"
							className={css.facebookBtn}
							id={SHARE_CONSTANTS.FACEBOOK}
							onClick={this.onShare}
						>
							<img src={fbIcon} alt="fb-icon" />
						</button>
					</div>
				</div>
				<AccessibilityIcon />
			</div>
		);
	}
}
